<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <HeaderSagres titulo="Hash UGs">
          <template #customContent>
          </template>
        </HeaderSagres>
      </template>
      <b-card-body class="p-0">
        <CardFiltrosBusca>
            <b-form @submit.prevent="loadData" @reset.prevent="limparFiltros">
              <b-row>
                <b-col cols="6" lg="3">
                    <b-form-group id="input-group-nome-ug" label-size="md" label="UG / URL / Hash">
                      <b-form-input 
                        v-model="filter"
                        debounce="300"
                        placeholder="Digite para filtrar"
                        class="mb-2"                        
                      ></b-form-input>                    
                    </b-form-group>
                </b-col>
                <b-col cols="6" lg="2" class="pt-4">
                    <b-button type="reset" variant="outline-secondary">
                    <font-awesome-icon icon="redo" class="mr-3" />Limpar
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
        </CardFiltrosBusca> 

        <b-table 
          :fields="fields" 
          :items="items" 
          :busy="loadingUgs" 
          hover 
          no-border-collapse 
          sort-by=""
          :sort-desc="true" 
          striped stacked="lg" responsive 
          show-empty
          :filter="filter"          
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>

          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark serigy-action-link" @click="alertaAlterarHashUg(row.item)">
                <font-awesome-icon icon="key" />
                <div class="serigy-action-label">Gerar Hash</div>
              </b-link>
              <b-link class="text-dark serigy-action-link" @click="toggleModalAlteraTransparenciaUg(row.item)">
                <font-awesome-icon icon="link" />
                <div class="serigy-action-label">Alterar URL</div>
              </b-link>   
            </div>         
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <modal-edit-url-transparencia v-if="exibirModalAlterarUrlUg" @fecharModal="toggleModalAlteraTransparenciaUg"
      @alterarUrlTransparencia="onAlterarUrlTransparencia" :item="item" />    
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import serigyService from "@/services/administracao/serigyService";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { TableField } from "@/types/table-field";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import ModalEditUrlTransparencia from "@/components/serigy/ModalEditUrlTransparencia.vue";
import { fieldsUgSerigy } from "@/types/administracao/serigy/ug-serigy/fields-ug-serigy";
import { Ug } from "@/types/administracao/serigy/ug-serigy/ug";


const CompProps = Vue.extend({
  name: "UgSerigy",
  components: {
    HeaderSagres,
    CardFiltrosBusca,    
    ModalEditUrlTransparencia
  },
});

@Component
export default class UgSerigy extends mixins(UtilsTS, CompProps) {  
  filter = "";
  fields: TableField[] = fieldsUgSerigy;
  items: Ug[] = [];
  loadingUgs = false;
  exibirModalAlterarUrlUg = false;
  item: Ug | undefined;
  // codUgSagres: string | null = "";

  async loadData(): Promise<void> {
    try {
      this.loadingUgs = true;
      this.items = await serigyService.listarUgs();
    } catch (error) {
      this.tratarError(error);
      this.items = [];
    } finally {
      this.loadingUgs = false;
    }
  }

  async onAlterarUrlTransparencia(): Promise<void> {
    try {
      this.loadingUgs = true      
      await this.loadData()
      this.toggleModalAlteraTransparenciaUg()
    } finally {
      this.loadingUgs = false
    }
  }  

  async alterarHashUg(hashUg: Ug): Promise<void> {
    try {
      await serigyService.alterarHashUg(hashUg.codUgSagres);
      await this.loadData();
    } catch (error) {
      this.tratarError(error);
    }
  }

  toggleModalAlteraTransparenciaUg(item?: Ug): void {    
    // this.codUgSagres = !!item ? item.codUgSagres : null;
    this.item = item;
    this.exibirModalAlterarUrlUg = !this.exibirModalAlterarUrlUg;
  }

  limparFiltros(): void {
    console.log("Limpar filtros");
    this.filter = '';
  }

  alertaAlterarHashUg(hashUg: Ug): void {
    this.$bvModal
      .msgBoxConfirm(
        `Ao confirmar, caso exista um hash associado à UG, ele será substituído. Deseja gerar um novo hash para a UG?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          okVariant: "secondary",
          title: "Gerar Hash",
        }
      )
      .then((value) => {
        if (value) {
          if (hashUg.codUgSagres) {
            this.alterarHashUg(hashUg);
          }
        }
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção de perfil`,
          err
        );
      });
  }

  mounted(): void {
    this.loadData();
  }
}
</script>
<style scoped>
span.sitBadge.success {
  color: #fff;
  background-color: #28a745;
}

span.sitBadge.warning {
  background-color: #ffc107;
}

span.sitBadge.danger {
  color: #fff;
  background-color: #dc3545;
}
</style>
